/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Form, FormElement } from '@progress/kendo-react-form';
import { Button, ButtonGroup, Container } from 'react-bootstrap';
import { mmurApi } from 'utility/axios_config';
import moment from 'moment';
import { SSN_EMPTY_MASK } from 'utility/constants';
import { toolsEndpoints } from 'endpoints/tools';
import { HsmvQueryFieldsPhoto } from './hsmv_query_fields_photo';
import { HsmvPhotoResultModal } from './hsmv_result_modal_photo';
// @ts-ignore
import styles from './tools.module.scss';
import { HsmvPhotoCheckValidatorFactory } from './hsmv_check_validator_photo';

function HsmvPhotoCheck(props) {
  const [showHsmvPhotoResultModal, setShowHsmvPhotoResultModal] = useState(false);
  const [hsmvResultData, setHsmvResultData] = useState('');
  const [modalTitle, setModalTitle] = useState('');
  const [modalSubtitle, setModalSubitle] = useState('');

  const handleSubmit = async (options) => {
    const params = {
      ...options,
      ssn: options.ssn && options.ssn !== SSN_EMPTY_MASK ? options.ssn : ''
    };

    const url = toolsEndpoints.getHsmvPhotoCheck(params);

    const title = 'Photo Search Results';

    const subTitle = () => {
      let stringBuilder = 'Results of checking: ';
      if (params.ssn && params.ssn !== SSN_EMPTY_MASK) {
        stringBuilder += `SSN: ${params.ssn} `;
        if (params.licenseNumber) {
          stringBuilder += 'and ';
        }
      }
      if (params.licenseNumber) {
        stringBuilder += `DL: ${params.licenseNumber} `;
      }
      const [dob] = params.dob.split('-');
      return `${stringBuilder}and DOB: ${dob} as of ${moment().format('MM/DD/YYYY hh:mm A')}`;
    };

    setModalTitle(title);
    setModalSubitle(subTitle);

    mmurApi.get(url).then(({ data: { data } }) => {
      // eslint-disable-next-line max-len
      setHsmvResultData(data);
      setShowHsmvPhotoResultModal(true);
    });
  };

  return (
    <Container className="text-center">
      <div>
        <h3>API Tools - HSMV Photos</h3>
      </div>
      <div>
        <Form
          onSubmit={handleSubmit}
          validator={HsmvPhotoCheckValidatorFactory()}
          render={(formRenderProps) => (
            <FormElement>
              <HsmvQueryFieldsPhoto
                formRenderProps={formRenderProps}
                categoryClientContent={props.categoryClientContent}
              />

              <div className={styles.hsmvPhotoToolButtons}>
                <ButtonGroup>
                  <Button
                    className={styles.hsmvPhotoToolButton}
                    onClick={() => formRenderProps.allowSubmit}
                    type="submit"
                    disabled={
                      !formRenderProps.allowSubmit || !formRenderProps.valid
                    }
                    variant="primary"
                  >
                    Submit
                  </Button>
                </ButtonGroup>
              </div>
            </FormElement>
          )}
        />
        <HsmvPhotoResultModal
          show={showHsmvPhotoResultModal}
          heading={modalTitle}
          subTitle={modalSubtitle}
          data={hsmvResultData}
          buttontext="Close"
          size="xl"
          onHide={() => setShowHsmvPhotoResultModal(false)}
          centered
          static="static"
          animation={false}
        />
      </div>
    </Container>
  );
}

function mapStateToProps(state) {
  return {
    categoryClientContent: state.content.categoryClientContent,
  };
}
export default connect(mapStateToProps)(HsmvPhotoCheck);
